var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8425_120923",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8425_120923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_2",
    d: "M13.9993 15.7294L8.08078 21.6482C7.9192 21.8096 7.7161 21.8922 7.47149 21.8961C7.22707 21.8998 7.02028 21.8172 6.85111 21.6482C6.68214 21.479 6.59766 21.2741 6.59766 21.0333C6.59766 20.7926 6.68214 20.5877 6.85111 20.4185L12.7699 14.5L6.85111 8.58151C6.68973 8.41993 6.60709 8.21683 6.6032 7.97222C6.5995 7.72781 6.68214 7.52101 6.85111 7.35185C7.02028 7.18287 7.22523 7.09839 7.46595 7.09839C7.70667 7.09839 7.91161 7.18287 8.08078 7.35185L13.9993 13.2706L19.9178 7.35185C20.0794 7.19046 20.2825 7.10782 20.5271 7.10393C20.7715 7.10024 20.9783 7.18287 21.1474 7.35185C21.3164 7.52101 21.4009 7.72596 21.4009 7.96668C21.4009 8.2074 21.3164 8.41235 21.1474 8.58151L15.2287 14.5L21.1474 20.4185C21.3088 20.5801 21.3915 20.7832 21.3954 21.0278C21.3991 21.2722 21.3164 21.479 21.1474 21.6482C20.9783 21.8172 20.7733 21.9016 20.5326 21.9016C20.2919 21.9016 20.0869 21.8172 19.9178 21.6482L13.9993 15.7294Z",
    fill: "var(--clr-info__dark)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.75cd1d1370efaa6e64a3a1a9a3a84ab0.svg";
export { ForwardRef as ReactComponent };